/**
 * Created by qlong on 10/5/2016.
 */
import React, {Component} from 'react'

export default class About extends Component{
    render(){
        return (
            <div className="childDiv aboutus">
                <h1>
                    About Spaghetti Chart
                </h1>

                <p>
                    The software is distributed as is, completely without warranty or service support.
                    Institute for Disease Modeling and its employees are not liable for the condition or performance of the software.
                </p>

                {/*<p>*/}
                    {/*Spaghetti Chart is licensed under the Creative Commons Attribution-Noncommercial-ShareAlike 4.0 License.*/}
                    {/*To view a copy of this license, visit <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/legalcode">https://creativecommons.org/licenses/by-nc-sa/4.0/legalcode</a>*/}
                {/*</p>*/}

                <p>
                    This product includes software developed at the following open source initiatives:
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td colSpan="2"><strong>babel</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/babel/babel">https://github.com/babel/babel</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/babel/babel/blob/master/LICENSE">https://github.com/babel/babel/blob/master/LICENSE</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>chroma-js</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/gka/chroma.js/">https://github.com/gka/chroma.js/</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/gka/chroma.js/blob/master/LICENSE">https://github.com/gka/chroma.js/blob/master/LICENSE</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>express</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/expressjs/express/?_ga=1.254583116.538955634.1476131186">https://github.com/expressjs/express/?_ga=1.254583116.538955634.1476131186</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/expressjs/express/blob/master/LICENSE">https://github.com/expressjs/express/blob/master/LICENSE</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>highcharts</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="http://www.highcharts.com/docs/getting-started/install-from-npm">http://www.highcharts.com/docs/getting-started/install-from-npm</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://creativecommons.org/licenses/by-nc/3.0/legalcode">https://creativecommons.org/licenses/by-nc/3.0/legalcode</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>lodash</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://lodash.com/">https://lodash.com/</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://raw.githubusercontent.com/lodash/lodash/4.16.4/LICENSE">https://raw.githubusercontent.com/lodash/lodash/4.16.4/LICENSE</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>papaparse</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/mholt/PapaParse">https://github.com/mholt/PapaParse</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/mholt/PapaParse/blob/master/LICENSE">https://github.com/mholt/PapaParse/blob/master/LICENSE</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>react</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/facebook/react">https://github.com/facebook/react</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/facebook/react/blob/master/LICENSE">https://github.com/facebook/react/blob/master/LICENSE</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>redux</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/reactjs/redux">https://github.com/reactjs/redux</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/reactjs/redux/blob/master/LICENSE.md">https://github.com/reactjs/redux/blob/master/LICENSE.md</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>webpack</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/webpack/webpack">https://github.com/webpack/webpack</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/webpack/webpack/blob/master/LICENSE">https://github.com/webpack/webpack/blob/master/LICENSE</a></td>
                        </tr>

                        <tr>
                            <td colSpan="2">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><strong>fixed-data-table</strong></td>
                        </tr>
                        <tr>
                            <td>URL:</td>
                            <td><a href="https://github.com/facebook/fixed-data-table">https://github.com/facebook/fixed-data-table</a></td>
                        </tr>
                        <tr>
                            <td>License:</td>
                            <td><a href="https://github.com/facebook/fixed-data-table/blob/master/LICENSE">https://github.com/facebook/fixed-data-table/blob/master/LICENSE</a></td>
                        </tr>
                    </tbody>
                </table>
                <br/><br/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/AouutUs.js
 **/